import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useAuth } from '../../contexts/AuthContext';
import { updateProfile } from '../../services/api';
import { Edit2, Check, X } from 'lucide-react';
import PhoneVerification from './PhoneVerification';


const UserProfile = () => {
  const { user, updateUserInfo, updateUser } = useAuth(); // 假設你加了 updateUserInfo

  const [isEditing, setIsEditing] = useState(false);
  const [newName, setNewName] = useState(user?.default_display_name || user?.display_name || '');
  const [loading, setLoading] = useState(false);

  console.log("Current User Object:", user)

  const handleSave = async () => {
    if (!newName.trim()) return;
    setLoading(true);
    try {
      const response = await updateProfile({ display_name: newName });
      // 💡 建議 1: 用 status >= 200 && status < 300 判定成功，因為有時後端會回傳 201 或 204
      if (response.status >= 200 && response.status < 300) {
        const freshData = response.data.raw_data;

        // 💡 建議 2: 點解要 call 三次 update？通常一個 AuthContext 只需要一個 updateUser 就夠
        // 將所有同步 LocalStorage 嘅邏輯封裝喺 updateUser 裡面
        updateUser(freshData);

        setIsEditing(false);
        // 完美體驗：用 Toast 代替 Alert 會專業好多（如果你有裝 Toast library 嘅話）
        alert("✅ 個人資料更新成功！");
      }
    } catch (err) {
      // 💡 建議 3: 完美解析錯誤訊息
      const errorData = err.response?.data;
      let errorMessage = "更新失敗，請稍後再試";

      if (typeof errorData === 'string') {
        errorMessage = errorData;
      } else if (typeof errorData === 'object') {
        // 拆解 DRF 的字典錯誤，例如 { "display_name": ["太長", "唔準用符號"] }
        // 攞出第一個錯誤嚟顯示
        const firstErrorKey = Object.keys(errorData)[0];
        const firstErrorValue = errorData[firstErrorKey];

        errorMessage = Array.isArray(firstErrorValue)
          ? `${firstErrorKey}: ${firstErrorValue[0]}`
          : (errorData.error || errorData.detail || "格式錯誤");
      }

      alert(`❌ ${errorMessage}`);
      console.error("Profile Update Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-gray-50 min-h-screen pb-24">
      <h1 className="text-2xl font-black text-gray-800 mb-8">帳號設定</h1>

      {/* 會員 QR Code —— 俾店員掃描識別身份,唔使講/打電話 */}
      {user?.user_id && (
        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden mb-6">
          <div className="p-6 flex flex-col items-center">
            <h2 className="text-lg font-bold text-gray-700 mb-1 self-start">會員 QR Code</h2>
            <p className="text-xs text-gray-400 mb-4 self-start">結帳/查詢時比店員掃描,唔使講電話</p>
            <div className="p-4 bg-white border border-gray-100 rounded-2xl">
              <QRCodeSVG value={user.user_id} size={180} level="H" />
            </div>
          </div>
        </div>
      )}

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-lg font-bold text-gray-700">基本資料</h2>
            {!isEditing ? (
              <button
                onClick={() => setIsEditing(true)}
                className="flex items-center gap-1 text-sm font-bold text-blue-600 bg-blue-50 px-3 py-1.5 rounded-full"
              >
                <Edit2 size={14} /> 編輯
              </button>
            ) : (
              <div className="flex gap-2">
                <button onClick={() => setIsEditing(false)} className="p-1.5 text-gray-400"><X size={20} /></button>
              </div>
            )}
          </div>

          <div className="space-y-6">
            {/* 姓名欄位 */}
            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-2">顯示姓名</label>
              {isEditing ? (
                <div className="flex gap-2">
                  <input
                    type="text"
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                    className="flex-1 bg-gray-50 border-2 border-blue-100 rounded-xl px-4 py-2 focus:border-blue-500 outline-none font-bold"
                    autoFocus
                  />
                  <button
                    onClick={handleSave}
                    disabled={loading}
                    className="bg-green-600 text-white p-2 rounded-xl shadow-md disabled:bg-gray-300"
                  >
                    <Check size={24} />
                  </button>
                </div>
              ) : (
                <p className="text-lg font-bold text-gray-800 ml-1">
                  {user?.default_display_name}
                </p>
              )}
            </div>

            {/* 電話欄位 —— 加/改一定要 OTP 驗證先寫得入,同註冊嗰段共用 SMS 服務 */}
            <PhoneVerification phone={user?.phone_number} onVerified={updateUser} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;